import React from "react"

function Articles(props) {
    return (
        <div>
            <h1>Articles & Updates</h1>
            <h2><code>Under Construction</code></h2>
            <div className = "text-wrapper">
            <p className = "blag-text">
                    30/04/2021 - Nice Updates!
                    Recently got an offer from BlackBerry! Really excited to be cooping with them over this summer!
                    Honestly can't wait to start and get learning.
                </p>
            </div>
            
            <div className = "text-wrapper">
                <p className = "blag-text">
                16/02/2021 - Website is live!
                    Gotta work on a format for these articles and things...
                    React is fun but very annoying when you get to making it look pretty.
                </p>
            </div>
        </div>
    )
}
export default Articles;